/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable func-names */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-console */
/* eslint no-param-reassign: "error" */
// @ts-nocheck
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppDispatch, AppThunk } from './index';
import {
  PermissoesTransportadoraResponse,
  PermissoesTransportadoraResponseListResult
} from '../api/lar.logistica.api';
import ClientFactory from '../api/ApiFactory';
import {
  blockUI,
  displayMessage,
  setRedirectTo,
  unblockUI
} from '../../core_web/store/Application.store';

const Logistica = createSlice({
  name: 'logistica',
  initialState: {
    permissoes: [] as PermissoesTransportadoraResponse[],
    currentEnrollment: String
  },
  reducers: {
    setPermissoes(state, action: PayloadAction<PermissoesTransportadoraResponse[]>) {
      state.permissoes = action.payload;
    },
    setCurrentEnrollment(state, action: PayloadAction<string>) {
      state.currentEnrollment = action.payload;
    }
  }
});

export const { setPermissoes, setCurrentEnrollment } = Logistica.actions;
export default Logistica.reducer;

export function obterPermissoes(): AppThunk {
  return async function (dispatch: AppDispatch | any | any) {
    dispatch(blockUI());
    const client = ClientFactory.GetClient();
    client
      .apiV1Permissoes()
      .then((result) => {
        dispatch(setPermissoes(result.data));
        localStorage.setItem('agendamentoPermissions', JSON.stringify(result.data));
      })
      .catch((err) => {
        dispatch(
          displayMessage({
            message:
              err.message === 'Unauthorized'
                ? 'Não Autorizado, Faça novamente o login'
                : `Não foi possivel obter as permissões: ${err.message}`,
            severity: 'error'
          })
        );
      })
      .finally(() => dispatch(unblockUI()));
  };
}

export function SetCurrentEnrollment(enrollment: string): AppThunk {
  return async function (dispatch: AppDispatch | any | any) {
    dispatch(setCurrentEnrollment(enrollment));
  };
}
